<template>
    <div class="quote">
        <DxLoadPanel
            :showIndicator="true"
            :indicator-src="loadingIndicatorUrl"
            :showPane="false"
            :visible="isLoading()"
            shading-color="rgba(0,0,0,0.4)"
            />

        <div class="header row">
            <div class="col-sm-2">
                <h5>{{caption}}</h5> 
            </div>
            <div class="col-sm-3 btn-group">
                <!--<button type="button" @click.prevent="(e) => toggleLoading(e)" class="request-quote-button btn btn-outline-info">Toggle Loading</button>-->
                <!--<button :disabled="!saveEnabled" v-if="quote.Options" type="button" @click.prevent="(e) => save(e)" class="save-quote-button btn btn-info">Save</button> -->
                <button :disabled="!submitEnabled" v-if="quote.Options" type="button" @click.prevent="(e) => request(e)" class="request-quote-button btn btn-outline-info">Request Quote</button>          
            </div>
        </div>
       
        <form class="section" v-if="quote.Id">            
            <div class="form-group row"> 
                <label class="col-sm-1 col-form-label">Summary</label> 
                <div class="col-sm-8"><span class="static-text">{{ quote.Summary }}</span></div>
                <label for="status" class="col-sm-1 col-form-label">Status</label> 
                <div class="col-sm-1">
                    <DxSelectBox
                        v-if="showAdminFields"
                        :data-source="statusCodes"
                        v-model:value="quote.StatusId"
                        display-expr="Description"
                        value-expr="Id"                        
                    />
                    <span class="static-text" v-else>{{ statusDescription }}</span>
                </div>
            </div>         
            <div v-if="showAdminFields" class="form-group row"> 
                <label for="organisation" class="col-sm-1 col-form-label">Organisation</label> 
                <div class="col-sm-2">
                    <DxSelectBox
                        :data-source="organisations"
                        v-model:value="quote.OrganisationId"
                        display-expr="Name"
                        value-expr="Id"
                    />
                </div>
                <label for="contact" class="col-sm-2 col-form-label">Contact</label> 
                <div class="col-sm-2">
                    <DxSelectBox
                        :data-source="orgContacts"
                        v-model:value="quote.ContactId"
                        :display-expr="getContactName"
                        value-expr="Id"
                        @value-changed="contactChanged"
                    />
                </div>
                <label for="type" class="col-sm-2 col-form-label">Type</label> 
                <div class="col-sm-2">
                    <DxSelectBox
                        :data-source="quoteTypes"
                        v-model:value="quote.TypeId"
                        display-expr="Description"
                        value-expr="Id"
                    />
                </div>
            </div>
            <div class="form-group row"> 
                <!--<label for="reference" class="col-sm-1 col-form-label">Reference</label> 
                <div class="col-sm-2">
                    <input id="reference" type="text" class="form-control" v-model="quote.Reference" />
                </div>-->
                <label for="terms" class="col-sm-1 col-form-label">Terms</label> 
                <div class="col-sm-8">
                    <!--<input id="terms" type="text" class="form-control" v-model="quote.Terms" />-->
                    <span class="static-text">{{ quote.Terms }}</span>
                </div>
                <label for="expires" class="col-sm-1 col-form-label">Expires</label> 
                <div class="col-sm-2">
                    <!--<input id="expires" type="text" class="form-control" v-model="quote.Expires" />-->
                    <span class="static-text">{{ formatDate(quote.Expires) }}</span>
                </div>
            
                <!--
                <label v-if="customField1Caption" for="customField1" class="col-sm-2 col-form-label">{{customField1Caption}}</label> 
                <div v-if="customField1Caption" class="col-sm-2">
                    <input id="customField1" type="text" :class="getCustomFieldClass(quote.CustomField1)" v-model="quote.CustomField1" />
                </div>
                <label v-if="customField2Caption" for="customField2" class="col-sm-2 col-form-label">{{customField2Caption}}</label> 
                <div v-if="customField2Caption" class="col-sm-2">
                    <input id="customField2" type="text" :class="getCustomFieldClass(quote.CustomField2)" v-model="quote.CustomField2" />
                </div>
                <label v-if="customField3Caption" for="customField3" class="col-sm-2 col-form-label">{{customField3Caption}}</label> 
                <div v-if="customField3Caption" class="col-sm-2">
                    <input id="customField3" type="text" :class="getCustomFieldClass(quote.CustomField3)" v-model="quote.CustomField3" />
                </div>
                <label v-if="customField4Caption" for="customField4" class="col-sm-2 col-form-label">{{customField4Caption}}</label> 
                <div v-if="customField4Caption" class="col-sm-2">
                    <input id="customField4" type="text" :class="getCustomFieldClass(quote.CustomField4)" v-model="quote.CustomField4" />
                </div>
                <label v-if="customField5Caption" for="customField5" class="col-sm-2 col-form-label">{{customField5Caption}}</label> 
                <div v-if="customField5Caption" class="col-sm-2">
                    <input id="customField5" type="text" :class="getCustomFieldClass(quote.CustomField5)" v-model="quote.CustomField5" />
                </div>-->
            </div>
        </form> 

        <div id="quote-results-anchor"></div>
        <div id="quote-results" class="section" v-if="responseData && responseData.length">

            <div v-if="responseData[0].usesNewCalcs">
                <div v-for="(section,index) in responseData" v-bind:key="index">
                    <div class="error" v-if="section.rows[0].Error">
                        {{ section.rows[0].Error }}
                    </div>
                    <div v-else>
                        <div v-if="minScreenWidth">
                            <table class="table" v-for="(col,index) in section.columns.slice(1)" v-bind:key="index">
                                <tr>
                                    <th colspan="2" class="left">{{ col.caption }}</th>
                                    <th> 
                                        <button 
                                            :disabled="!submitEnabled" 
                                            type="button" 
                                            @click.prevent="(e) => confirmAccept(e,section.columns[index+1].quoteNo)" 
                                            class="btn btn-accept" 
                                            :quoteno="section.columns[index+1].quoteNo">
                                            Accept
                                        </button>     
                                    </th>
                                </tr>
                                <tr>
                                    <th></th>
                                    <th class="right" v-for="(col2,cind) in col.columns" v-bind:key="cind">{{ col2.caption }}</th>
                                </tr>
                                <tr v-for="(row,rind) in section.rows" v-bind:key="rind">
                                    <td>{{ row.rowDesc }}</td>
                                    <td class="right">{{ row.totals[index] }}</td>
                                </tr>
                            </table>
                        </div>
                        <div v-else>
                            <table class="table">
                                <tr>
                                    <th class="results-col-1"></th>
                                    <template v-for="(col,index) in section.columns.slice(1)" v-bind:key="index">
                                        <th :class="['right results-col-' + (index+2)]">{{ section.columns[index+1].caption }}</th>
                                    </template>                
                                    <th class="results-col-99"></th>
                                </tr>
                                <tr>
                                    <th></th>
                                    <template v-for="(col,index) in section.columns.slice(1)" v-bind:key="index">
                                        <th class="right">{{ col.columns[0].caption }}</th>
                                    </template>
                                </tr>
                                <tr v-for="(row,index) in section.rows" v-bind:key="index">
                                    <td>{{ row.rowDesc }}</td>
                                    <td v-for="(total,tind) in row.totals" v-bind:key="tind" class="right">{{ total }}</td>
                                </tr>
                                <tr>
                                    <th></th>
                                    <template v-for="(col,index) in section.columns.slice(1)" v-bind:key="index">
                                        <th class="right">
                                            <button 
                                                :disabled="!submitEnabled" 
                                                type="button" 
                                                @click.prevent="(e) => confirmAccept(e,section.columns[index+1].quoteNo)" 
                                                class="btn btn-accept" 
                                                :quoteno="section.columns[index+1].quoteNo">
                                                Accept
                                            </button>          
                                        </th>
                                    </template>                
                                </tr>
                            </table>                
                        </div>
                    </div>
                    <div v-if="section.msg" class="section bold" v-html="section.msg" />
                    <div v-if="section.calcInfoMsg" class="section bold" v-html="section.calcInfoMsg" />
                </div>
            </div>
            <div v-else> 
                <div v-for="(section,index) in responseData" v-bind:key="index">
                    <div class="error" v-if="section.rows[0].Error">
                        {{ section.rows[0].Error }}
                    </div>
                    <div v-else>
                        <div v-if="minScreenWidth">
                            <table class="table" v-for="(col,index) in section.columns.slice(1)" v-bind:key="index">
                                <tr>
                                    <th colspan="2" class="left">{{ col.caption }}</th>
                                    <th> 
                                        <button 
                                            :disabled="!submitEnabled" 
                                            type="button" 
                                            @click.prevent="(e) => confirmAccept(e,section.columns[index+1].quoteNo)" 
                                            class="btn btn-accept" 
                                            :quoteno="section.columns[index+1].quoteNo">
                                            Accept
                                        </button>     
                                    </th>
                                </tr>
                                <tr>
                                    <th></th>
                                    <th class="right" v-for="(col2,cind) in col.columns" v-bind:key="cind">{{ col2.caption }}</th>
                                </tr>
                                <tr v-for="(row,rind) in section.rows" v-bind:key="rind">
                                    <td>{{ row.rowDesc }}</td>
                                    <td v-for="(total,tind) in row.totals.slice((index*2),(index*2)+2)" v-bind:key="tind" class="right">{{ total }}</td>
                                </tr>
                            </table>
                        </div>
                        <div v-else>
                            <table class="table">
                                <tr>
                                    <th></th>
                                    <template v-for="(col,index) in section.columns.slice(1)" v-bind:key="index">
                                        <th class="right">{{ section.columns[index+1].caption }}</th>
                                        <th>
                                            <button 
                                                :disabled="!submitEnabled" 
                                                type="button" 
                                                @click.prevent="(e) => confirmAccept(e,section.columns[index+1].quoteNo)" 
                                                class="btn btn-accept" 
                                                :quoteno="section.columns[index+1].quoteNo">
                                                Accept
                                            </button>          
                                        </th>
                                    </template>                
                                </tr>
                                <tr>
                                    <th></th>
                                    <template v-for="(col,index) in section.columns.slice(1)" v-bind:key="index">
                                        <th class="right">{{ col.columns[0].caption }}</th>
                                        <th class="right">{{ col.columns[1].caption }}</th>
                                    </template>
                                </tr>
                                <tr v-for="(row,index) in section.rows" v-bind:key="index">
                                    <td>{{ row.rowDesc }}</td>
                                    <td v-for="(total,tind) in row.totals" v-bind:key="tind" class="right">{{ total }}</td>
                                </tr>
                            </table>                
                        </div>
                    </div>
                    <div v-if="section.msg" class="section bold" v-html="section.msg" />
                </div>
            </div>
            
            <div class="section" v-html="disclaimerText" /> 
        </div>

        <div class="modal fade" id="acceptModal" tabindex="-1" aria-labelledby="acceptModalLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="acceptModalLabel">Accept Quote</h5>
                    </div>
                <div class="modal-body">
                    Confirm you wish to order this vehicle
                </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" @click.prevent="(e) => accept(e)">OK</button>
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
        
        <navigator ref="navigator" v-if="renderNavigator" :value="quote" :on-value-changed="(value) => onValueChanged(value)" />
    </div>
</template>

<script>
    //import { DxDataGrid } from 'devextreme-vue/data-grid';
    import DxSelectBox from 'devextreme-vue/select-box';
    import DataSource from 'devextreme/data/data_source';
    import { createStore } from 'devextreme-aspnet-data-nojquery';
    import { DxLoadPanel } from 'devextreme-vue/load-panel';
    import { Modal } from 'bootstrap';

    import Navigator from './Navigator.vue';
    
    export default {
    components: { 
        //DxDataGrid, 
        DxSelectBox,
        DxLoadPanel,
        Navigator },
        name: 'Quote',
        data() {
            return {   
                contId: 0,
                quote: {},
                showAdminFields: false,
                isSaved: false,
                organisations: [],
                contacts: [],
                quoteTypes: [],
                statusCodes: [],
                responseData: [],
                statusDescription: null,
                pendingQuoteStatusId: null,
                customField1Caption: null,
                customField2Caption: null,
                customField3Caption: null,
                customField4Caption: null,
                customField5Caption: null,
                loading: false,
                renderNavigator: true,
                rendering: true,
                windowWidth: window.innerWidth
            };
        },
        computed: {
            caption: function() {
                if(this.quote && this.quote.Id) {
                    return 'Quote ' + this.quote.Id;
                } else {
                    return 'Quote';
                }
            },
            orgContacts: function() {
                return {
                    store: this.contacts,
                    filter: this.quote.OrganisationId ? ['OrganisationId', '=', this.quote.OrganisationId] : null
                };
            },
            saveEnabled: function() {
                //if(this.showAdminFields) {
                //    return true;               
                //}

                //return (this.quote.StatusId == this.pendingQuoteStatusId) && (this.quote.CustomField1) && (this.quote.CustomField2);
                return true;
            },
            isPending() {
                return (this.quote.StatusId == this.pendingQuoteStatusId);
            },
            isErrorResponse() {

                //console.log(this.responseData);

                if(this.responseData) {
                    if(this.responseData.find(obj => obj.rows[0].Error))
                        return true;
                }

                return false;
            },
            submitEnabled: function() {  
                
                var lastStage = (this.$refs.navigator) ? this.$refs.navigator.isLastStage() : false;

                //return lastStage && (this.isPending || this.quote.StatusId == null) && !this.rendering;
                
                return lastStage && !this.rendering;
                
                // (this.quote.StatusId == this.pendingQuoteStatusId) && (this.quote.CustomField1) && (this.quote.CustomField2) &&
                // (this.quote.OrganisationId) && this.quote.OrganisationId != 0 &&
                //    (this.quote.ContactId) && this.quote.ContactId != 0; 
            },
            minScreenWidth: function() {
                return this.windowWidth < 992;
            }
        },
        created: function () {

            addEventListener('routeClicked', (e) => { this.reset(); } );

            //console.log('Created');
            this.rendering = true;

            //console.log(this.$route);

            var quoteId = this.$route.params.id;
            
            //console.log(quoteId);

            this.contId = localStorage.getItem('contactId');
            this.pendingQuoteStatusId = this.getSetting('PendingQuoteStatusId');
            this.disclaimerText = this.getSetting('QuotationDisclaimerText');
            this.customField1Caption = this.getSetting('CustomField1Caption');
            this.customField2Caption = this.getSetting('CustomField2Caption');
            this.customField3Caption = this.getSetting('CustomField3Caption');
            this.customField4Caption = this.getSetting('CustomField4Caption');
            this.customField5Caption = this.getSetting('CustomField5Caption');
                  
            if(this.getPermissions("Organisation").Read) {
                this.showAdminFields = true;
                this.organisations = createStore({
                    key: 'Id',
                    loadUrl: this.apiUrl + 'organisations',
                    loadMode:"raw",
            
                    onBeforeSend: (method, ajaxOptions) => {                                
                        ajaxOptions.headers = this.getHeaders()
                    }});
            }
            if(this.getPermissions("Contact").Read) {
                this.contacts = createStore({
                    key: 'Id',
                    loadUrl: this.apiUrl + 'contacts',
                    loadMode:"raw",
            
                    onBeforeSend: (method, ajaxOptions) => {                                
                        ajaxOptions.headers = this.getHeaders()
                    }});
            }
            this.quoteTypes = createStore({
                key: 'Id',
                loadUrl: this.apiUrl + 'quotetypes',
                loadMode:"raw",
        
                onBeforeSend: (method, ajaxOptions) => {                                
                    ajaxOptions.headers = this.getHeaders()
                }});

            this.statusCodes = createStore({
                key: 'Id',
                loadUrl: this.apiUrl + 'statuscodes/quote',
                loadMode:"raw",
        
                onBeforeSend: (method, ajaxOptions) => {                                
                    ajaxOptions.headers = this.getHeaders()
                }});
           
            this.reset();
            if(quoteId !== undefined && quoteId != ':id') {
                this.get(this.apiUrl + "contacts/" + this.contId + "/quotes/" + quoteId,this.init);              
            }
            else {
              //var orgId = localStorage.getItem('organisationId');            
              //this.post(this.apiUrl + "contacts/" + this.contId + "/quotes", 
              //  { contactId: this.contId, organisationId: orgId }, this.init);                
            }
        },
        mounted: function () {
            window.addEventListener('resize', () => {
                this.windowWidth = window.innerWidth
            });
        },
        updated: function() {
            //console.log('Updated');
            var _this = this;
            setTimeout(() => this.rendering = false, 2000);
        },
        methods: {        
            init(data) {
                
                this.quote = data;
              
                this.updateStatusDescription();           
                
                //TODO: make this dynamic (computed?)
                if(this.quote.Response) {       

                   //console.log(this.quote.Response);
                    //console.log(JSON.parse(this.quote.Response));

                    if(!Array.isArray(this.quote.Response))
                    {
                        this.responseData = JSON.parse(this.quote.Response); //this.createDataSource(JSON.parse(this.quote.Response));
                    }

                    this.enableAcceptButtons(this.quote.StatusId == this.pendingQuoteStatusId);
                }

                //console.log('init: done');
            },
            async reset() {
                this.quote = {};
                this.responseData = {};
                var navigator = this.$refs['navigator'];
                if(navigator) {
                    navigator.initStage(0);
                    //navigator.$forceUpdate();
                    this.renderNavigator = false;

                    await this.$nextTick();

                    this.renderNavigator = true;
                }
                //this.$forceUpdate(); 
            },
            getClass() {
                return this.isErrorResponse ? "error" : "";
            },
            enableAcceptButtons(enable) {
                var acceptButtons = document.getElementsByClassName('btn btn-accept');
                if(acceptButtons) {
                    Array.from(acceptButtons).forEach((el) => {
                        el.disabled = enable;
                    });
                }
            },
            onValueChanged(value) {
                this.quote.Options = value;
                this.enableAcceptButtons(false);              
             
                var navigator = this.$refs['navigator'];
                var options = navigator.extractOptions();

                //console.log("Before:",this.quote.Options);

                var optionsDS = [18,56,57];

                var summary = '';                
                this.quote.Options.forEach(option => {
                  
                    //if(option.DataSourceId == 18) {
                    if(optionsDS.includes(option.DataSourceId)) {
                        try {
                            //console.log(option.Selection);
                            var arr = option.Selection;
                            if(!Array.isArray(arr))
                                arr = JSON.parse(arr);  
                            if(Array.isArray(arr)) {
                                var ds = options.find(o => o.DataSourceId == option.DataSourceId);
                                if(ds) {
                                    option.Selection = ds.Selection;
                                }
                            }
                        }
                        catch(err) {
                            console.log("Error:",err);
                        }
                    }
                    
                    if(option.Summary) {
                        if(summary != '') {
                            summary += '/' + option.Summary;
                        } else {
                            summary = option.Summary;
                        }
                    }
                });

                //console.log("After:",this.quote.Options);

                this.quote.Summary = summary;
            },
            createDataSource(data) {
                if(typeof data == "string") {
                    try {
                        data = JSON.parse(data);
                    } catch(e) {
                        data = [];
                    }
                }

                if(!(data)) {
                    data = [];
                }
            
                return new DataSource({ store:data });
            },
            getContactName(contact) {    
                return contact && contact.FirstName + ' ' + contact.LastName;
            },
            contactChanged(e) {
                var contactId = e.value;
                if(contactId) {
                    this.contacts.byKey(contactId).then((contact) => {
                        this.quote.CustomField1 = contact.CustomField1;
                        this.quote.CustomField2 = contact.CustomField2;
                        this.quote.CustomField3 = contact.CustomField3;
                        this.quote.CustomField4 = contact.CustomField4;
                        this.quote.CustomField5 = contact.CustomField5;
                    });
                }                
            },
            getCustomFieldClass(e) {
                var cssClass = 'form-control';
                if(e) {
                    cssClass += ' is-valid';
                } else {
                    cssClass += ' is-invalid';
                }
                return cssClass;
            },
            onRowPrepared(info) {
                if(info.rowIndex == 3){
                    info.rowElement.style.fontWeight = "bold";
                }
            },
            onCellPrepared(info) {
                if(info.column.quoteNo) {
                    var button = document.createElement('button');
                    button.type = 'button';
                    button.innerHTML = 'Accept';
                    button.className = 'btn btn-accept';
                    button.quoteNo = info.column.quoteNo;
                    button.onclick = this.accept;  
                    info.cellElement.appendChild(button);
            
                    //info.cellElement.firstChild.cssClass = "header-cell";
                    info.cellElement.firstChild.style.paddingTop = "7px";
                    info.cellElement.firstChild.style.fontWeight = "bold";
                }
            },
            updateStatusDescription() {
                if(!this.showAdminFields) {
                    this.statusCodes.byKey(this.quote.StatusId)
                        .then((s) => {                             
                            this.statusDescription = s.Description;
                        });
                }
            },
            request(e) {

                //console.log(this.quote.Options);

                var quoteId = this.quote.Id;
                if(quoteId == undefined || quoteId == ':id') {
                    var orgId = localStorage.getItem('organisationId');      
                    this.onValueChanged(this.quote.Options);      
                    this.post(this.apiUrl + "contacts/" + this.contId + "/quotes", 
                    { contactId: this.contId, organisationId: orgId, summary: this.quote.Summary, options: this.quote.Options }, (data) => {
                        //this.quote = data;
                        this.submit(data);
                    });                                      
                } else {
                    this.submit(this.quote);
                } 
            },
            submit(quote) {
                var _this = this;

                //console.log(quote);

                this.loading = true;
                this.quote.Response = null;
                quote.DisplayPrice = null;
                this.responseData = null;
                
                this.post(this.apiUrl + 'quotes/' + quote.Id +'/submit',quote,
                    function(response) {
                        _this.quote.Id = response.Id;
                        _this.quote.OrganisationId = response.OrganisationId;
                        _this.quote.ContactId = response.ContactId;
                        _this.quote.Expires = response.Expires;
                        _this.quote.StatusId = response.StatusId;
                        _this.quote.Response = response.Response;
                        _this.responseData = _this.quote.Response;
                        _this.quote.Terms = response.Terms;
                        _this.quote.Options = response.Options;
                        _this.updateStatusDescription();
                        _this.loading = false;
                                     
                        if((!_this.responseData) || _this.responseData.length == 0)
                            _this.responseData = [ { "rows": [ { "Error": "Unable to get quotation details at this time." } ]} ];
                  
                        document.getElementById("quote-results-anchor").scrollIntoView();
                        
                        var navigator = _this.$refs['navigator'];
                        navigator.applyOptions(_this.quote.Options);
                        
                        _this.rendering = false;                       
                    });   
            },
            confirmAccept(e,quoteNo) {
                this.acceptedQuoteNo = quoteNo;
                var modal = new Modal(document.getElementById('acceptModal'));
                modal.show();
            },
            accept(e) {
                //if(!confirm('Are you sure you want to accept this quote?'))
                //    return;
                
                var _this = this;
                var quoteId = this.quote.Id;
                var url = this.apiUrl + 'quotes/' + quoteId + '/accept';    
               
                var data = {};
                data.QuoteNo = this.acceptedQuoteNo;
                this.loading = true;
                                
                this.post(url, data, function(response) {
                    _this.quote.StatusId = _this.getSetting('AcceptedQuoteStatusId');   
                    _this.loading = false;    
                    _this.setAcceptedQuoteId(quoteId);
                    _this.$router.push({ name: 'Quote Accepted', params: { id: quoteId } });  
                });
            
            /*
            this.$http.post(url, data,
              {
                  headers: this.getHeaders()
              })
              .then((response) => {        
                  console.log(response);            
                  var data = JSON.parse(response.data[0].data).return_value;
                  //destSchema.response =  data;
              }, (error) => {
                  console.log(error);
              });*/
            },
            toggleLoading() {
                this.loading = !this.loading;
            },
            isLoading() {

                var navigatorLoading = (this.$refs.navigator) ? this.$refs.navigator.loading : false;

                return this.loading || navigatorLoading;
            }       
        },
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    .summary-cell {
        vertical-align: middle;
    }
    
    #results-grid-0 {
        border: none;
    }

    #results-grid-0 > div {
        min-width: 1024px;
        margin-top:10px;
        margin-bottom: 10px;
        border-radius: 10px!important;
        background: #eeeeee;
        padding: 10px;
    }

    #results-grid-0 .dx-datagrid-headers {
        border: none;
    }

    button.btn.btn-accept {
        float: right;
        background: rgb(15, 44, 97)!important;
        border: rgb(15, 44, 97)!important
    }
    .header.row {
        padding-bottom: 10px;
    }
    .section {
        border: 1px solid #eeeeee;
        background: #eeeeee;
        padding: 5px;
        margin-bottom: 10px;
        border-radius: 10px;
    }
    div.error div.dx-datagrid-text-content,
    div.error {
        padding-left: 5px;
        font-weight: bolder;
        color: red;
    }
    .right {
        text-align: right;
    }
    .centre {
        text-align: center;
    }
    .table {
        background-color: white;
        border-radius: 10px;
        border-spacing: 10px;
        border-collapse: separate;
        width: auto;
    }

    th.results-col-1 { min-width: 250px }
    th.results-col-2 { min-width: 200px }
    th.results-col-3 { min-width: 200px }
    th.results-col-99 { width: 100% }

    .bold {
        font-weight: bold;
    }

    @media (max-width: 992px) {
        #results-grid-0 > div {
            min-width: unset;
            max-width: 100%;
        }

        .dx-datagrid-content .dx-datagrid-table.dx-datagrid-table-fixed {
            /* max-width: 350px!important; */
        }

        div.filters-table {
            display: inline-block;
        }
        div.filter-container {
            float: left;
        }
        div.dx-item.dx-tab {
            padding: 3px!important;    
        }
        button.request-quote-button {
            position: fixed!important;
            z-index:100;
            bottom: 0;
            width: 80%;
        }
    }
    
</style>

